// extracted by mini-css-extract-plugin
export default {"container":"PageHeader_container__tjylR","image":"PageHeader_image__z2T56","title":"PageHeader_title__32PVi","subtitle":"PageHeader_subtitle__GAnkR"};